import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVideo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M5.75 2.75v14.5m0-7.25h-4m16.5 0h-4m-8.5 3.5h-4m16.5 0h-4m-8.5-7h-4m16.5 0h-4m0-3.75v14.5m-10.5 0h12.5a2 2 0 0 0 2-2V4.75a2 2 0 0 0-2-2H3.75a2 2 0 0 0-2 2v10.5a2 2 0 0 0 2 2Z"
	})]
});
const ForwardRef = forwardRef(SvgVideo);
export { ForwardRef as ReactComponent };
